import { scrollToHash } from "@/components/Reveal";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Network", href: "#network" },
  { label: "Contact", href: "#contact" },
];

const OFFICES = [
  [
    "Rewa - HQ",
    [
      "+91 92320 69697",
      "Flat No.: GISN 00239",
      "C/O VANSHROOP VISHWAKRMA Khamhari",
      "District: Rewa, Madhya Pradesh",
      "PIN Code: 486111",
    ],
  ],
  ["Mumbai", ["+91 92320 69697", "Sagar city, Andheri West Mumbai"]],
];

export function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/10">
      <div className="grid gap-12 px-6 py-16 md:grid-cols-3 lg:px-12 lg:py-20">
        <div>
          <p className="font-display text-2xl font-semibold uppercase tracking-tight">
            PORTWAVE<span className="text-[#FF3B30]">.</span>
          </p>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/50">
            International logistics for companies that cannot afford to wait.
            Founded 2024, Rewa.
          </p>
        </div>

        <nav aria-label="Footer">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-white/40">
            Navigate
          </p>
          <ul className="mt-5 space-y-3">
            {NAV.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  data-testid={`footer-link-${link.label.toLowerCase()}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToHash(link.href);
                  }}
                  className="text-sm text-white/60 transition-colors duration-300 hover:text-[#FF3B30]"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-white/40">
            Offices
          </p>
          <ul className="mt-5 space-y-5">
            {OFFICES.map(([city, lines]) => (
              <li key={city} className="text-sm">
                <span className="text-white/80">{city}</span>
                <span className="mt-1 block space-y-1 text-white/40">
                  {lines.map((line) => (
                    <span key={line} className="block">
                      {line}
                    </span>
                  ))}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="overflow-hidden px-6 lg:px-12">
        <p
          aria-hidden="true"
          className="select-none text-center font-display text-[16.5vw] font-semibold uppercase leading-[0.8] tracking-tighter text-white/[0.06]"
        >
          PORTWAVE
        </p>
      </div>

      <div className="flex flex-col gap-3 border-t border-white/10 px-6 py-6 text-xs uppercase tracking-[0.2em] text-white/40 sm:flex-row sm:items-center sm:justify-between lg:px-12">
        <p>Â© 2026 PORTWAVE Logistics</p>
        <p className="flex items-center gap-2" data-testid="footer-status">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#FF3B30] opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-[#FF3B30]" />
          </span>
          All routes operational
        </p>
      </div>
    </footer>
  );
}